import axios from 'axios';
import type { ApiError } from 'admin-shared';

// ADR 0.6: baseURL uses same-origin path — Vite proxy forwards to LibreChat :3080 in dev
export const adminApi = axios.create({
  baseURL: '/api/admin/v1',
  withCredentials: true,           // session cookie forwarded through Vite proxy
  headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.response.use(
  r => r,
  err => {
    const data = err.response?.data as ApiError | undefined;
    return Promise.reject(data?.error ?? err);
  },
);
